import { forwardRef, InputHTMLAttributes } from "react";
import { Loader2 } from "lucide-react";

import SearchIcon from "~/assets/search.svg";
import { cn } from "~/services/shadcn";

export const SearchInput = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { isLoading?: boolean }
>(({ className, isLoading = false, ...props }, ref) => (
  <div className="relative flex w-full flex-1">
    <input
      ref={ref}
      type="text"
      style={{ backgroundColor: "transparent" }}
      className={cn(
        "relative min-w-0 flex-1 rounded-xs border-none bg-search-gradient py-2 pl-10 pr-11 font-medium text-[#F7FAFD] placeholder:font-normal placeholder:text-[#444444] focus:outline-none focus:outline-2 focus:outline-[#F1B93B]/70",
        className,
      )}
      placeholder="Search..."
      {...props}
    />

    <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 fill-[#444]" />

    {isLoading && (
      <div className="absolute bottom-0 right-4 top-0 flex items-center justify-end">
        <Loader2 className="h-5 w-5 animate-spin stroke-2 text-[#444] duration-500" />
      </div>
    )}
  </div>
));

SearchInput.displayName = "SearchInput";
